export const styles = {
  page: (isMobile) => ({
    padding: isMobile ? 12 : 28,
    flex: 1,
    minHeight: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    overflowY: "auto",
    background: "linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%)",
  }),
  headerRow: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: isMobile ? "flex-start" : "center",
    gap: isMobile ? 8 : 14,
    marginBottom: isMobile ? 16 : 24,
  }),
  iconBadge: (isMobile) => ({
    width: isMobile ? 44 : 48,
    height: isMobile ? 44 : 48,
    borderRadius: isMobile ? 12 : 14,
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    boxShadow: "0 16px 32px rgba(31, 58, 112, 0.14)",
  }),
  title: (isMobile) => ({
    margin: 0,
    fontSize: isMobile ? 20 : 22,
    color: "#1f3a70",
  }),
  subtitle: (isMobile) => ({
    margin: isMobile ? "4px 0 0" : "6px 0 0",
    fontSize: isMobile ? 13 : 14,
    color: "#5d6f8a",
    lineHeight: isMobile ? 1.4 : 1.5,
  }),

   emptyState: (isMobile) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: isMobile ? 24 : 48,
    gap: 16,
    color: "#cbd5e1",
  }),
  emptyMessage: {
    margin: 0,
    color: "#5d6f8a",
    fontSize: 14,
  },
  card: (isMobile) => ({
    width: "100%",
    background: "rgba(255,255,255,0.98)",
    borderRadius: 22,
    padding: isMobile ? 16 : 28,
    boxShadow: "0 20px 50px rgba(34, 60, 80, 0.08)",
    border: "1px solid rgba(31, 58, 112, 0.08)",
    boxSizing: "border-box",
  }),
  sectionHeader: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: "space-between",
    gap: isMobile ? 12 : 16,
    alignItems: "flex-start",
    marginBottom: isMobile ? 16 : 24,
  }),
  cardTitle: (isMobile) => ({
    margin: 0,
    fontSize: isMobile ? 16 : 18,
    color: "#15233c",
  }),
  cardDescription: (isMobile) => ({
    margin: isMobile ? "6px 0 0" : "8px 0 0",
    color: "#6a7c96",
    fontSize: isMobile ? 13 : 14,
  }),
  toolbarContainer: (isMobile) => ({
    display: "flex",
    flexDirection: "column",
    gap: isMobile ? 10 : 12,
    marginBottom: isMobile ? 16 : 18,
  }),
  searchWrapper: (isMobile) => ({
    position: "relative",
    display: "flex",
    alignItems: "center",
    marginBottom: isMobile ? 8 : 0,
  }),
  searchIcon: (isMobile) => ({
    position: "absolute",
    left: isMobile ? 12 : 14,
    color: "#5d6f8a",
    pointerEvents: "none",
  }),
  searchInput: (isMobile) => ({
    width: "100%",
    padding: isMobile ? "10px 14px 10px 40px" : "12px 14px 12px 44px",
    borderRadius: isMobile ? 14 : 16,
    border: "1px solid rgba(31, 58, 112, 0.14)",
    fontSize: isMobile ? 13 : 14,
    color: "#223047",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  }),
  toolbarActions: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    gap: 10,
    alignItems: isMobile ? "stretch" : "center",
    width: isMobile ? "100%" : "auto",
  }),
  sortSelect: (isMobile) => ({
    padding: isMobile ? "12px 14px" : "10px 12px",
    borderRadius: 12,
    border: "1px solid rgba(31, 58, 112, 0.14)",
    fontSize: isMobile ? 14 : 13,
    color: "#223047",
    background: "#ffffff",
    cursor: "pointer",
    outline: "none",
    transition: "border-color 0.2s ease",
    width: isMobile ? "100%" : "auto",
  }),
  addButton: (isMobile) => ({
    padding: isMobile ? "12px 16px" : "10px 16px",
    borderRadius: 12,
    border: "none",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    fontSize: isMobile ? 14 : 13,
    fontWeight: 700,
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    boxShadow: "0 8px 16px rgba(31, 58, 112, 0.16)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    whiteSpace: "nowrap",
    width: isMobile ? "100%" : "auto",
  }),
  addButtonIcon: (isMobile) => ({
    marginTop: -1,
    marginRight: isMobile ? 4 : 0,
  }),
  appointmentList: {
    display: "grid",
    gap: 14,
    height: 240,
    overflowY: "auto",
    overflowX: "hidden",
    paddingRight: 8,
    borderRadius: 14,
    background: "rgba(31, 58, 112, 0.02)",
  },
  appointmentItem: (isMobile) => ({
    display: isMobile ? "flex" : "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: isMobile ? "flex-start" : "space-between",
    alignItems: isMobile ? "flex-start" : "flex-start",
    gap: isMobile ? 12 : 14,
    padding: isMobile ? 14 : 18,
    borderRadius: isMobile ? 16 : 18,
    background: "#f7f9ff",
    border: "1px solid rgba(31, 58, 112, 0.08)",
    marginBottom: 12,
    position: isMobile ? "relative" : "static",
  }),
  appointmentPhoto: (isMobile) => ({
    width: isMobile ? 48 : 56,
    height: isMobile ? 48 : 56,
    borderRadius: isMobile ? 10 : 12,
    objectFit: "cover",
    flexShrink: 0,
    border: "2px solid rgba(31, 58, 112, 0.1)",
  }),
  appointmentContent: (isMobile) => ({
    flex: 1,
    minWidth: 0,
    marginLeft: isMobile ? 0 : 14,
  }),
  appointmentHeader: (isMobile) => ({
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: isMobile ? "flex-start" : "space-between",
    alignItems: isMobile ? "flex-start" : "flex-start",
    gap: isMobile ? 8 : 12,
    width: isMobile ? "100%" : "auto",
    marginBottom: 8,
  }),
  appointmentTitle: (isMobile) => ({
    margin: 0,
    fontSize: isMobile ? 15 : 16,
    color: "#15233c",
    fontWeight: 700,
  }),
  appointmentRecipient: (isMobile) => ({
    margin: isMobile ? "2px 0 0" : "4px 0 0",
    fontSize: isMobile ? 12 : 13,
    color: "#5d6f8a",
  }),
  statusBadge: (status, isMobile) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: isMobile ? "4px 8px" : "6px 10px",
    borderRadius: 999,
    fontSize: isMobile ? 11 : 12,
    fontWeight: 700,
    textTransform: "capitalize",
    background: status === "enviada" ? "rgba(34, 169, 96, 0.12)" : "rgba(25, 82, 255, 0.12)",
    color: status === "enviada" ? "#1f7b3a" : "#1b4abf",
  }),

  typeBadge: (type, isMobile) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: isMobile ? "4px 8px" : "6px 10px",
  borderRadius: 999,
  fontSize: isMobile ? 11 : 12,
  fontWeight: 700,
  marginLeft: isMobile ? 0 : 8,
  background:
    type === "campanha"
      ? "rgba(255, 165, 0, 0.12)"
      : "rgba(31, 58, 112, 0.12)",
  color: type === "campanha" ? "#b45309" : "#1f3a70",
}),
  appointmentDescription: (isMobile) => ({
    margin: 0,
    color: "#5d6f8a",
    fontSize: isMobile ? 12 : 13,
    lineHeight: isMobile ? 1.4 : 1.5,
  }),
  appointmentMeta: (isMobile) => ({
    whiteSpace: isMobile ? "nowrap" : "nowrap",
    fontSize: isMobile ? 11 : 13,
    color: "#1f3a70",
    fontWeight: isMobile ? 600 : 700,
    position: isMobile ? "absolute" : "static",
    top: isMobile ? 12 : "auto",
    right: isMobile ? 12 : "auto",
    background: isMobile ? "rgba(255,255,255,0.9)" : "transparent",
    padding: isMobile ? "3px 6px" : 0,
    borderRadius: isMobile ? 6 : 0,
    border: isMobile ? "1px solid rgba(31, 58, 112, 0.1)" : "none",
  }),
  emptyMessage: {
    marginTop: 6,
    color: "#5d6f8a",
    fontSize: 14,
  },
  tag: {
    display: "inline-flex",
    padding: "8px 14px",
    borderRadius: 999,
    background: "rgba(31, 58, 112, 0.08)",
    color: "#1f3a70",
    fontSize: 12,
    fontWeight: 700,
  },
  formGroup: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 10,
    marginBottom: 18,
  },
  label: {
    color: "#48627a",
    fontSize: 13,
    fontWeight: 600,
  },
  optionGroup: (isMobile) => ({
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(2, minmax(260px, 1fr))",
    gap: 10,
  }),
  optionButton: {
    width: "100%",
    padding: "12px 16px",
    borderRadius: 14,
    border: "1px solid rgba(31, 58, 112, 0.12)",
    background: "#ffffff",
    color: "#384765",
    cursor: "pointer",
    transition: "all 0.25s ease",
    textAlign: "left",
    fontWeight: 600,
    boxShadow: "0 4px 16px rgba(31, 58, 112, 0.04)",
    minWidth: 0,
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
  },
  optionButtonIcon: {
    display: "grid",
    placeItems: "center",
  },
  optionButtonActive: {
    borderColor: "#1f3a70",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    boxShadow: "0 14px 30px rgba(31, 58, 112, 0.16)",
  },
  input: {
    width: "100%",
    minHeight: 46,
    padding: "12px 14px",
    borderRadius: 16,
    border: "1px solid rgba(31, 58, 112, 0.14)",
    fontSize: 14,
    color: "#223047",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
  },
  textarea: {
    width: "100%",
    minHeight: 140,
    padding: "14px 16px",
    borderRadius: 18,
    border: "1px solid rgba(31, 58, 112, 0.14)",
    fontSize: 14,
    color: "#223047",
    resize: "vertical",
    outline: "none",
    boxSizing: "border-box",
    lineHeight: 1.6,
  },
  helpText: {
    marginTop: 4,
    color: "#7a8ba8",
    fontSize: 12,
  },
  submitButton: {
    width: "100%",
    marginTop: 6,
    padding: "14px 18px",
    borderRadius: 16,
    border: "none",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
    color: "#fff",
    fontSize: 15,
    fontWeight: 700,
    cursor: "pointer",
    transition: "transform 0.2s ease, box-shadow 0.2s ease",
    boxShadow: "0 16px 30px rgba(31, 58, 112, 0.22)",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
  },
  submitButtonIcon: {
    marginTop: -1,
  },

  appointmentPhotoFallback: (isMobile) => ({
    width: isMobile ? 48 : 56, 
    height: isMobile ? 48 : 56,
    borderRadius: isMobile ? 10 : 12, 
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f1f3f5",
    border: "2px solid rgba(31, 58, 112, 0.1)",
    color: "#6c757d",
    flexShrink: 0,
  }),

  loadingOverlay: (isMobile) => ({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255,255,255,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    borderRadius: isMobile ? 16 : 22,
  }),

spinner: (isMobile) => ({
  width: isMobile ? 32 : 40,
  height: isMobile ? 32 : 40,
  border: isMobile ? "3px solid #cbd5e1" : "4px solid #cbd5e1",
  borderTop: isMobile ? "3px solid rgb(31, 58, 112)" : "4px solid rgb(31, 58, 112)",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
}),

spinnerSmall: (isMobile) => ({
  width: isMobile ? 16 : 18,
  height: isMobile ? 16 : 18,
  border: isMobile ? "1.5px solid #ddd" : "2px solid #ddd",
  borderTop: isMobile ? "1.5px solid #1f3a70" : "2px solid #1f3a70",
  borderRadius: "50%",
  animation: "spin 0.8s linear infinite"
})
};
